<template>
	<v-btn
		v-bind="props"
		class="ao-btn"
		:class="customClass"
		:loading="loading"
		@click="$emit('click', $event)"
	>
		<AoIcon
			v-if="prependIconName"
			:iconName="prependIconName"
			:size="iconSize"
		/>
		<slot>
			{{ text }}
		</slot>
		<AoIcon
			v-if="appendIconName"
			:iconName="appendIconName"
			:size="iconSize"
		/>
	</v-btn>
</template>

<script>
import AoIcon from './AoIcon.vue'

export default {
	name: 'AoBtn',

	components: {
		AoIcon,
	},

	props: {
		custom: {
			type: String,
			default: null,
			validator: (value) => {
				return [
					'navigationLink',
					'softDelete',
					'hardDelete',
					'tabLink',
					'filterSelectedItem',
					'preset-tab',
					'tool',
					'referenceMaterialsLinksCustomBtn',
					'mapPresetCustomBtn',
					'popupActionCustomBtn',
					'favoriteSettingMenuItem',
					'dashboardCardAction',
					'bottomNavigationLink',
				].includes(value)
			}
		},

		text: {
			type: String,
		},

		prependIconName: {
			type: String,
			default: null,
		},

		appendIconName: {
			type: String,
			default: null,
		},

		iconSize: {
			type: [String, Number],
			default: null,
		},

		active: {
			type: Boolean,
			default: false,
		},

		disabled: {
			type: Boolean,
			default: false,
		},

		block: {
			type: Boolean,
			default: false,
		},

		variant: {
			type: String,
			default: 'elevated',
			// TODO: add validation
		},
		color: {
			type: String,
			default: undefined,
		},

		height: {
			type: [String, Number],
			default: undefined,
		},

		size: {
			type: String,
			default: null,
		},

		to: [Object, String],

		href: String,

		replace: Boolean,

		exact: Boolean,

		loading: Boolean,
	},

	emits: ['click'],

	computed: {
		props() {
			const props = {}
			if (this.color) props.color = this.color
			if (this.custom) {
				if (this.custom === 'navigationLink') {
					props.variant = 'text'
					props.color = this.active ? 'primary' : undefined
					props.height = 31
				} else if (this.custom === 'softDelete') {
					props.variant = 'tonal'
					props.color = 'error'
				} else if (this.custom === 'hardDelete') {
					props.variant = 'elevated'
					props.color = 'error'
				} else if (this.custom === 'tabLink') {
					props.variant = 'text'
					props.color = this.active ? 'white' : undefined
					props.height = 36
				} else if (this.custom === 'filterSelectedItem') {
					props.variant = 'text'
					props.color = 'primary'
					props.height = 22
					props.rounded = true
				} else if (this.custom === 'preset-tab') {
					props.variant = 'text'
					props.size = 'small'
					props.rounded = false
					props.height = 54
				} else if (this.custom === 'tool') {
					props.variant = 'text'
				} else if (this.custom === 'referenceMaterialsLinksCustomBtn') {
					props.variant = this.variant
					// props.activeColor = 'primary'
					props.block = true
					props.class = 'left-sidebar-btn content-left reference-materials-links-custom-btn'
				} else if (this.custom === 'mapPresetCustomBtn') {
					props.variant = 'text'
					props.size = 'small'
					props.block = true
					props.height = 24
					props.class = 'content-left my-1'
				} else if (this.custom === 'popupActionCustomBtn') {
					props.variant = 'text'
					props.size = 28
				} else if (this.custom === 'favoriteSettingMenuItem') {
					props.height = 24
					props.size = 'small'
					props.variant = 'text'
					props.block = true
					props.class = 'content-left'
				} else if (this.custom === 'dashboardCardAction') {
					props.height = 24
					props.size = 'small'
					props.variant = 'text'
					props.class = 'dashboard-card-action-btn'
				} else if (this.custom === 'bottomNavigationLink') {
					props.variant = 'text'
					props.color = this.active ? 'primary' : undefined
				}
			} else {
				if (this.block) props.block = this.block
				if (this.variant) props.variant = this.variant
				if (this.color) props.color = this.color
				if (this.height) props.height = this.height
				if (this.size) props.size = this.size
			}
			if (this.active !== undefined) props.active = this.active
			if (this.disabled) props.disabled = this.disabled
			if (this.to) props.to = this.to
			if (this.href) props.href = this.href
			if (this.replace) props.replace = this.replace
			if (this.exact) props.exact = this.exact
			if (this.text) props.text = this.text
			return props
		},

		customClass() {
			let prefix = 'ao-custom-btn-'
			let customClass = ''
			if (this.custom) {
				customClass = prefix + this.custom
			}
			return customClass
		},
	},
}
</script>

<style lang="scss">
.ao-btn {
	text-transform: none;
	letter-spacing: 0 !important;
	// &.ao-custom-btn- {
	// 	&navigationLink {}
	// }

	.v-btn__content {
		gap: 8px;
	}

	&.reference-materials-links-custom-btn {

		.v-btn__content {
			white-space: normal;
		}

	}

	&.dashboard-card-action-btn {
		border-width: 1px;
	}
}
.ao-custom-btn-navigationLink {
	display: flex;
	justify-content: flex-start;
}
.ao-custom-btn-bottomNavigationLink {

	.v-btn__content {
		display: flex;
		flex-direction: column;
		gap: 8px
	}

}
.ao-custom-btn-tabLink.v-btn--active {
	background-color: white !important;
	display: flex;
	justify-content: flex-start;
	border-radius: 6px 6px 0px 0px;
	span.v-btn__content {
		color: #1d2126;
	}
}
.ao-custom-btn-tabLink {
	color: #86919d;
	.v-btn__content {
		padding-bottom: 5px;
	}
}
.ao-custom-btn-background-color-default {
	border: none;
}
.ao-custom-btn-tool {
	border: 1px dashed #d3d9e0;
	color: rgb(var(--v-theme-textSecondary700));
	min-width: 32px !important;
	min-height: 32px !important;
	width: 32px !important;
	height: 32px !important;
}
.ao-custom-btn-preset-tab {
	&.v-btn {
		span.v-btn__content {
			color: #86919d;
		}
		&.v-btn:hover {
			&::after {
				content: '';
				height: 2px;
				background: #86919d;
				opacity: 1;
				bottom: 0;
				top: auto;
			}
		}
		&.v-btn:hover > .v-btn__overlay {
			background-color: white !important;
		}
		&::after {
			border: none;
		}
	}
	&.v-btn--active {
		background-color: white !important;
		&::after {
			content: '';
			height: 2px;
			background: rgb(var(--v-theme-primary)) !important;
			opacity: 1;
			bottom: 0;
			top: auto;
		}
		span.v-btn__content {
			color: #1d2126;
		}
		span.v-btn__overlay {
			background-color: white !important;
		}
	}
}
.ao-custom-btn-popupActionCustomBtn {
	border-width: thin;
	border-style: dashed;

	&:hover {
		border: none;
	}

}
.ao-btn.content-left {
	display: flex;
	justify-content: start;
}
.left-sidebar-btn {
	color: #576674;
}
.v-btn--active.left-sidebar-btn {
	background-color: rgb(var(--v-theme-primary));
	color: white;
	.v-btn__content {
		color: white !important;
	}
}
.left-sidebar-btn:hover:not(.v-btn--active) {
	background-color: #ecf1f7;
}
</style>
